<template>
<div v-loading.fullscreen.lock="fullscreenLoading">

    <!--コンテンツ-->
    <main id="renew2_mypage">
        <div class="quickemail_container">
            <div class="renew2_wrapper renew2_flex">
                <div class="servicelist">
                    <ul class="servicelist__block renew2_pc">
                        <li class="servicelist__item waiting"><a href="/mypage"><img src="/static/renew2_img/icon_mypagetop.svg" alt="マイページ"><br>マイページ</a></li>
                        <li class="servicelist__item waiting"><a href="/mypage/yagioffer"><img src="/static/renew2_img/icon_yagioffer.svg" alt="ヤギオファー"><br>ヤギオファー</a></li>
                        <li class="servicelist__item waiting"><a href="/mypage/quickmail"><img src="/static/renew2_img/icon_quickmail.svg" alt="ヤギの宅配便"><br>ヤギの宅配便</a></li>
                        <li class="servicelist__item onclick"><a href="/mypage/quickemail"><img src="/static/renew2_img/icon_quickemail.svg" alt="ヤギのメール便"><br>ヤギのメール便</a></li>
                        <li class="servicelist__item waiting"><a href="/mypage/introduction"><img src="/static/renew2_img/icon_recommend.svg" alt="推薦・紹介文"><br>推薦・紹介文</a></li>
                    </ul>
                    <div class="renew2_sp">
                        <ul class="servicelist__block renew2_sp_flex">
                            <li class="servicelist__item waiting"><a href="/mypage/yagioffer"><img src="/static/renew2_img/icon_yagioffer.svg" alt="ヤギオファー"><br>ヤギオファー</a></li>
                            <li class="servicelist__item waiting"><a href="/mypage/quickmail"><img src="/static/renew2_img/icon_quickmail.svg" alt="ヤギの宅配便"><br>ヤギの宅配便</a></li>
                            <li class="servicelist__item onclick"><a href="/mypage/quickemail"><img src="/static/renew2_img/icon_quickemail.svg" alt="ヤギのメール便"><br>ヤギのメール便</a></li>
                            <li class="servicelist__item waiting"><a href="/mypage/introduction"><img src="/static/renew2_img/icon_recommend.svg" alt="推薦・紹介文"><br>推薦・紹介文</a></li>
                        </ul>
                    </div>
                </div>
                <div class="mypage_contents">
                    <div class="renew2_flex lead">
                        <h2>ヤギのメール便</h2>
                        <a v-if="$site.appFlag!='b' || true" href="https://rirekisho.yagish.jp/quickemailhelp" target="_blank" class="">ヤギのメール便について</a>
                    </div>
                    <p v-if="$site.appFlag!='b'">あなたの履歴書等を入力後すぐに応募先企業にメールで送ることができます。<br>
                    必要項目を入力後、クレジットカード支払いとなります。</p>
                    <div class="quickemail_block">
                        <p class="not_used">現在、利用履歴はありません。</p>

                        <ul class="quickemail_block__list">

                            <li v-for="(item, index) in quickemailList.qemail_list" :key="index" class="renew2_flex quickemail_block__item">
                                <div class="status renew2_flex renew2_sp_flex">
                                    <p class="date">{{item.regist_date}}</p>
                                    <p class="offer_status status_read" v-if="item.read_flag=='1'">既読</p>
                                    <p class="offer_status status_undecided" v-else-if="item.cancel_flag=='1'">ｷｬﾝｾﾙ</p>
                                    <p class="offer_status status_unread" v-else-if="item.read_flag=='0'">未読</p>
                                </div>
                                <p class="company">{{item.quickmail_companyname}}</p>
                                <p class="status"><span class="buy">購入</span>•••<span class="sent">自動送信済み</span></p>
                                <div v-if="!item.detail_display" class="confirmation_btn" @click="!item.detail_display?item.detail_display=true:item.detail_display=false">
                                    <label for="confirmation1" class="confirmation">送信内容</label>
                                </div>
                                <div v-else class="confirmation_btn" @click="!item.detail_display?item.detail_display=true:item.detail_display=false">
                                    <label for="confirmation1" class="confirmation"><i class="el-icon-circle-close-outline"></i> 閉じる</label>
                                </div>
                                <div class="dropdown1" v-if="item.detail_display">
                                    <p>応募先企業名：<span>{{item.quickmail_companyname}}</span></p>
                                    <p>企業メールアドレス：<span>{{item.quickmail_staffemail}}</span></p>
                                    <p>送信日時：<span>{{item.quickmail_regist_date}}</span></p>
                                    <div class="download-status">
                                        <p class="download-status__title">応募先企業のダウンロード状況</p>
                                        <div class="download-status__box">
                                            <p v-if="item.rirekisho_download_flag=='1'">履歴書ダウンロード　<span >未</span>･･･<span class="done">済</span></p>
                                            <p v-else>履歴書ダウンロード　<span class="done">未</span>･･･<span class="unconfirmed">済</span></p>
                                            <p v-if="item.keirekisho_flag=='1' && item.keirekisho_download_flag=='1'">職務経歴書ダウンロード　<span >未</span>･･･<span class="done">済</span></p>
                                            <p v-else-if="item.keirekisho_flag=='1'">職務経歴書ダウンロード　<span class="done">未</span>･･･<span class="unconfirmed">済</span></p>
                                            <p class="download-status__limit">閲覧期限：<span>{{item.quickmail_authentication_key_limit_time}}まで</span></p>
                                        </div>
                                        <a @click="openQuickEmailDetailDialog(index)" >送付した履歴書を確認する</a>
                                        <p>送信した履歴書はポップアップで確認することができます。<br>また、応募先企業がPDFをダウンロードするとあなたへ通知されます。</p>
                                    </div>
                                    <p>差出人名：<span>{{item.from_name}}</span></p>
                                    <p>差出人メールアドレス：<span>{{item.from_email}}</span></p>
                                    <el-button v-if="item.read_flag == '0' && item.cancel_flag == '0'" class="cancel"
                                    @click="openQuickemailCancelModal(index)">送付をキャンセルする</el-button>
                                </div>
                            </li>


                        </ul>
                        
                    </div>
                    <div class="renew2_sp">
                        <a href="/mypage" class="servicelist__mypage"><img src="/static/renew2_img/icon_mypagetop.svg" alt="マイページ">マイページに戻る</a>
                    </div>
                </div>
            </div>
        </div>
    </main>

    <modal name="qemail-detail-dialog"
            :adaptive="true"
            :scrollable="true"
            height="auto"
            @opened="setQEmailPreviewScale();previewQEmailLoading=false">
      <div class="v--modal-close-top">
        <el-button @click="$modal.hide('qemail-detail-dialog')"
            icon="el-icon-circle-close-outline"
            style="font-size: 2rem;"
            type="text"></el-button>
      </div>
      
      <div class="backup-preview-dialog">

        <el-tabs v-model="activeQEmailPreviewTab"
                  class="backup-tabs"
                  :stretch="true"
                  @tab-click="setQEmailPreviewScale();previewQEmailLoading=false">
          <el-tab-pane
                        label="履歴書"
                        name="format_rirekisho"
                        :lazy="true"
                        :style="qmailViewerCssRirekisho">
                  <div v-html="qmail_rirekisho_html"
                  ref="rirekisho_pane"
                  :style="scaleQEmailStyle"></div>
          </el-tab-pane>
          <el-tab-pane  v-if="selectedQuickEmailData.keirekisho_flag=='1'"
                        label="職務経歴書"
                        name="format_shokumukeirekisho"
                        :lazy="true"
                        :style="qmailViewerCssShokurekisho">
                  <div v-html="qmail_shokumukeirekisho_html"
                  ref="shokumukeirekisho_pane"
                  :style="scaleQEmailStyle"></div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </modal>
    <modal name="qemail-cancel-confirm-dialog"
            :adaptive="true"
            :scrollable="true"
            height="auto">
      <div class="v--modal-close-top">
        <el-button @click="$modal.hide('qemail-cancel-confirm-dialog')"
            icon="el-icon-circle-close-outline"
            style="font-size: 2rem;"
            type="text"></el-button>
      </div>
      
      <div class="backup-preview-dialog">

        <div data-v-2a36762b="" class="formats-info">
          <h2>送信をキャンセルしますか。</h2>
          <p>※返金は行いませんので、ご了承ください。</p>
          <br>
          <div data-v-2a36762b="" class="title">
              <p data-v-2a36762b="">送信先会社名：{{ selectedQuickEmailData.quickmail_companyname }}</p>
          </div>
          <div class="formats-info_company">
              <div data-v-2a36762b="" class="system">送信先担当者名：{{ selectedQuickEmailData.quickmail_staffname }} 様</div>
              <div data-v-2a36762b="" class="system">送信先メールアドレス：{{ selectedQuickEmailData.quickmail_staffemail }}</div>
          </div>
        </div>
        <div class="text-right" v-if="selectedQuickEmailData.read_flag == '0' && selectedQuickEmailData.cancel_flag == '0'">
          <el-button type="primary"
                      @click="cancelQuickemail">送付をキャンセルする</el-button>
        </div>
      </div>
    </modal>


</div>
</template>

<style lang="css" src="@/assets/css/renew2_mypage.css"></style>


<style scoped>
</style>



<script>
import {
  TabPane,
  Tabs,
  MessageBox
} from 'element-ui'
import RirekishoPreview from '@/components/formats/RirekishoPreview'
import ShokurekishoPreview from '@/components/formats/ShokurekishoPreview'
import LoginForms from '@/components/RenewLoginForms'
import firebase from 'firebase/app'

const RECENT_EDIT_SAVE_KEY = 'recentEdit'
const DOC_PAPER_HEIGHT_PX = 794
export default {
  components: {
    'rirekisho-preview': RirekishoPreview,
    'shokurekisho-preview': ShokurekishoPreview,
    'el-tabs': Tabs,
    'el-tab-pane': TabPane,
    'login-forms': LoginForms
  },
  data: function () {
    return {
		  fullscreenLoading: true,
      recentEdit: {
        FormatId: ''
      },
      introData: {},
      backupList: {
        auto: [],
        user: []
      },
      dialogVisible:false,
      selectedYagiOfferData:{},
      selectedQuickEmailData:{},
      yagiOfferData: [],
      quickemailList: [],
      qmail_rirekisho_html: '',
      qmail_shokumukeirekisho_html: '',
      backupListLoaded: {
        auto: false,
        user: false
      },
      saved: false,
      recomm_code:'',
      saveLabel: '',
      backupDataToConfirm: null,
      previewScale: 1,
      previewQEmailScale: 1,
      backupDataViewerCssRirekisho: {},
      backupDataViewerCssShokurekisho: {},
      qmailViewerCssRirekisho: {},
      qmailViewerCssShokurekisho: {},
      deleteBackupPopoverVisible: false,
      previewLoading: false,
      rirekisho_height: 110,
      keirekisho_height: 110,
      previewQEmailLoading: false,
      activeTabName: 'user',
      activePreviewTab: 'format_rirekisho',
      activeQEmailPreviewTab: 'format_rirekisho'
    }
  },
  computed: {
    scaleQEmailStyle: function () {
      const _style = {
        'transform': 'scale(' + this.previewQEmailScale + ')',
        'transform-origin': 'top left',
        'height': (this.rirekisho_height * this.previewQEmailScale)
      }
      return _style
    }
  },
  methods: {
    setQEmailPreviewScale: function () {
      this.$nextTick(function () {
        
        if (this.activeQEmailPreviewTab === 'format_rirekisho') {
          if (this.$refs.rirekisho_pane.clientWidth === 0) {
          } else {
            const clientWidth = this.$refs.rirekisho_pane.clientWidth
            this.previewQEmailScale = clientWidth / Math.max(clientWidth, DOC_PAPER_HEIGHT_PX)
          }
        } else if (this.activeQEmailPreviewTab === 'format_shokumukeirekisho') {
          if (this.$refs.shokumukeirekisho_pane.clientWidth === 0) {
          } else {
            const clientWidth = this.$refs.shokumukeirekisho_pane.clientWidth
            this.previewQEmailScale = clientWidth / Math.max(clientWidth, DOC_PAPER_HEIGHT_PX)
          }
        }
        this.$nextTick(function () {
          this.setQEmailPreviewHeight()
        })
      })
    },
    setQEmailPreviewHeight: function () {
      if (this.activeQEmailPreviewTab === 'format_rirekisho') {
        const height = this.$refs.rirekisho_pane.getBoundingClientRect().height
        this.qmailViewerCssRirekisho = {
          height: height + 30 + 'px'
        }
        this.rirekisho_height = height + 30
      } else if (this.activeQEmailPreviewTab === 'format_shokumukeirekisho') {
        const height = this.$refs.shokumukeirekisho_pane.getBoundingClientRect().height
        this.qmailViewerCssShokurekisho = {
          height: height + 30 + 'px'
        }
        this.keirekisho_height = height + 30
      }
    },
    openDialog: function () {
      this.$modal.show('confirm-backup-dialog')
      this.backupDataViewerCssRirekisho = {}
      this.backupDataViewerCssShokurekisho = {}
    },
    closeDialog: function () {
      this.$modal.hide('confirm-backup-dialog')
      this.deleteBackupPopoverVisible = false
    },
    confirmBackup: function (backup) {
      // console.log(backup)
      this.backupDataToConfirm = backup
      this.previewLoading = true
      this.openDialog()
    },
    openQuickemailCancelModal: function (idx) {
      this.selectedQuickEmailData = this.quickemailList.qemail_list[idx]
      this.$modal.show('qemail-cancel-confirm-dialog')
    },
    cancelQuickemail: function () {
      const app = this
      const formData = new FormData()
      formData.append('history_id', this.selectedQuickEmailData.history_id)
      formData.append('uuid', app.$firebase.user.uid)

      this.$axios
        .post(this.$varuna.endPoints.cancelQuickemail, formData, {timeout: 60000})
        .then(function (response) {
          app.$message({
            message: '送信キャンセルを完了しました',
            type: 'info'
          })
          app.selectedQuickEmailData.cancel_flag='1'
          app.$modal.hide('qemail-cancel-confirm-dialog')
        })
        .catch(function (error) {})
        .finally(function () {})
    },
    setDefaultSaveLabel: function () {
      if (this.$yagi.profile.name) {
        this.saveLabel = this.$yagi.profile.name + 'のバックアップ'
      } else {
        this.saveLabel = 'バックアップ'
      }
    },
    saveBackup: function () {
      if (this.$yagi.profile.name) {
        this.saveLabel = this.$yagi.profile.name + 'のバックアップ'
      } else {
        this.saveLabel = 'バックアップ'
      }
      this.$firebase.addBackup(this.saveLabel, 'user')
      this.loadBackupList('user')
      this.saved = true
    },
    loadBackupList: function (type) {
      const app = this
      app.backupListLoaded[type] = false
      app.backupList[type] = []
      app.$firebase.getBackupList('all', 5)
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            app.backupList[type].push({
              id: doc.id,
              value: doc.data()
            })
          })
          app.backupListLoaded[type] = true
        })
        .catch(function (err) {
          console.error(err)
        })
    },
    loadBackup: function (backup) {
      this.$firebase.loadBackup(backup.id)
      this.closeDialog()
    },
    deleteBackup: function (backup) {
      this.$firebase.deleteBackupWithMessage(backup.id, backup.value.label)
      console.log('deleteBackup', backup)
      this.getBackups(true)
      this.closeDialog()
    },
    openYagiOfferDetailDialog: function (idx) {
      this.$modal.show('offer-detail-dialog')
      this.selectedYagiOfferData = this.yagiOfferData.offer_list[idx]
      console.error(this.selectedYagiOfferData)
      if (this.selectedYagiOfferData.read_flag != '1') {
        const app = this
        const formData = new FormData()
        formData.append('offer_id', this.selectedYagiOfferData.offer_id)
        formData.append('uuid', app.$firebase.user.uid)

        this.$axios
          .post(this.$varuna.endPoints.readYagiOffer, formData, {timeout: 60000})
          .then(function (response) {})
          .catch(function (error) {})
          .finally(function () {})
      }
    },
    openQuickEmailDetailDialog: function (idx) {
      this.$modal.show('qemail-detail-dialog')
      this.selectedQuickEmailData = this.quickemailList.qemail_list[idx]
      console.error(this.selectedQuickEmailData)
      this.qmail_rirekisho_html = this.selectedQuickEmailData.rirekisho_html
      this.qmail_shokumukeirekisho_html = this.selectedQuickEmailData.keirekisho_html
      this.qmailViewerCssRirekisho = {}
      this.qmailViewerCssShokurekisho = {}
    },
    dataChanged: function () {
      this.saved = false
      this.setDefaultSaveLabel()
    },
    submitOffer: function () {
      const app = this
      const formData = new FormData()
      formData.append('offer_id', this.selectedYagiOfferData.offer_id)
      formData.append('uuid', app.$firebase.user.uid)

      this.$axios
        .post(this.$varuna.endPoints.submitYagiOffer, formData, {timeout: 60000})
        .then(function (response) {
          for(let _item of app.yagiOfferData.offer_list){
            if (app.selectedYagiOfferData.offer_id == _item.offer_id) {
              _item.offer_status = 'accept'
            }
          }
          app.$message({
            duration: 3000,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `オファーを承認しました`,
            type: 'success'
          })
        })
        .catch(function (error) {
          app.$message({
            duration: 3000,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `オファーの承認処理を失敗しました`,
            type: 'error'
          })
        }).finally(function () {
          
        })
      console.error(this.selectedYagiOfferData.offer_id)
    },
    denyOffer: function () {
      const app = this
      const formData = new FormData()
      formData.append('offer_id', this.selectedYagiOfferData.offer_id)
      formData.append('uuid', app.$firebase.user.uid)

      this.$axios
        .post(this.$varuna.endPoints.denyYagiOffer, formData, {timeout: 60000})
        .then(function (response) {
          for(let _item of app.yagiOfferData.offer_list){
            if (app.selectedYagiOfferData.offer_id == _item.offer_id) {
              _item.offer_status = 'refuse'
            }
          }
          app.$message({
            duration: 3000,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `オファーを辞退しました`,
            type: 'success'
          })
        })
        .catch(function (error) {
          app.$message({
            duration: 3000,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `オファーの辞退処理を失敗しました`,
            type: 'error'
          })
        }).finally(function () {
          
        })
      console.error(this.selectedYagiOfferData.offer_id)
    },
    loadRecentEdit: function () {
      const app = this
      this.$getItem(RECENT_EDIT_SAVE_KEY, function (err, data) {
        if (err) {
          console.log(err)
        }
        if (data) {
          app.recentEdit = data
        }
      })
    },
    getBackups: function (force) {
      if (this.$deviceLib.isOnline && this.$firebase.isAuthenticated) {
        if (force) {
          this.loadBackupList('auto')
          this.loadBackupList('user')
        } else {
          if (!this.backupListLoaded['user']) {
            this.loadBackupList('user')
          }
          if (!this.backupListLoaded['auto']) {
            this.loadBackupList('auto')
          }
        }
      }
    }
  },
  created: function () {
    const app = this
    // console.log(this.$route.query.mynavi)
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {    
        console.log('logined')
        const formData = new FormData()
        formData.append('access_id', '')
        formData.append('uuid', app.$firebase.user.uid)
        formData.append('device_flg', app.$deviceLib.isMobileDevice ? 'SP': 'PC')
        formData.append('version', '2')
        formData.append('reqflg', '2')

        this.$axios
          .post(this.$varuna.endPoints.getIntroduction, formData, {timeout: 60000})
          .then(function (response) {
            app.introData = response.data
            app.recomm_code =  "/recomm_preview/" + response.data.access_id
          })
        this.$axios
          .post(this.$varuna.endPoints.getYagiOfferList, formData, {timeout: 60000})
          .then(function (response) {
            app.yagiOfferData = response.data
          })
        this.$axios
          .post(this.$varuna.endPoints.getQuickemailList, formData, {timeout: 60000})
          .then(function (response) {
            app.quickemailList = response.data
          })
	      this.fullscreenLoading = false

      } else {
        this.$router.push('/login')
      }
    })
    this.loadRecentEdit()
  },
  beforeMount: function () {
    this.$eventHub.$on('basic-data-changed', this.dataChanged)
    this.$eventHub.$on('format-data-changed', this.dataChanged)
    this.$eventHub.$on('firebase-initialized', this.getBackups)
    this.$eventHub.$on('yagi-profile-loaded', this.setDefaultSaveLabel)
    this.$eventHub.$on('yagi-profile-saved', this.setDefaultSaveLabel)
    this.setDefaultSaveLabel()
    this.getBackups()
  },
  destroyed: function () {
    this.$eventHub.$off('basic-data-changed', this.dataChanged)
    this.$eventHub.$off('format-data-changed', this.dataChanged)
    this.$eventHub.$off('firebase-initialized', this.getBackups)
    this.$eventHub.$off('yagi-profile-loaded', this.setDefaultSaveLabel)
    this.$eventHub.$off('yagi-profile-saved', this.setDefaultSaveLabel)
  }
}
</script>
